import {
  doc,
  endBefore,
  getDoc,
  getDocs,
  limit,
  limitToLast,
  orderBy,
  query,
  startAfter,
} from 'firebase/firestore';
import { Student } from '../types/student';
import BaseService from './base-service';

class StudentsService extends BaseService<Student> {
  constructor() {
    super('students');
  }

  async getAll(): Promise<Student[]> {
    const q = query(
      this.collectionRef,
      orderBy('firstYear', 'desc'),
      orderBy('name')
    );
    const students: Student[] = [];
    const snapshot = await getDocs(q);
    snapshot.forEach((doc) => {
      students.push({ id: doc.id, ...(doc.data() as Student) });
    });

    return students;
  }

  async getNext(student: Student): Promise<Student | undefined> {
    const docRef = doc(this.collectionRef, this.getDocIdAsString(student.id!));
    const docSnap = await getDoc(docRef);
    const q = query(
      this.collectionRef,
      orderBy('firstYear', 'desc'),
      orderBy('name'),
      startAfter(docSnap),
      limit(1)
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      return undefined;
    }

    const documentSnapshot = snapshot.docs[0];
    return { id: documentSnapshot.id, ...(documentSnapshot.data() as Student) };
  }

  async getPrev(student: Student): Promise<Student | undefined> {
    const docRef = doc(this.collectionRef, this.getDocIdAsString(student.id!));
    const docSnap = await getDoc(docRef);
    const q = query(
      this.collectionRef,
      orderBy('firstYear', 'desc'),
      orderBy('name'),
      endBefore(docSnap),
      limitToLast(1)
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      return undefined;
    }

    const documentSnapshot = snapshot.docs[0];
    return { id: documentSnapshot.id, ...(documentSnapshot.data() as Student) };
  }
}

const studentsService = new StudentsService();
export default studentsService;
